import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MenuService } from '../../services/menu.service';
import { UserApiService } from '../../services/user-api.service';
import { OrdersApiService } from './../../services/orders-api.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  public selectedLanguage = 'en-GB';
  public languagePanelOpen = false;

  constructor(
    private menuService: MenuService,
    private ordersApiService: OrdersApiService,
    private adapter: DateAdapter<any>,
    private translate: TranslateService,
    public userApiService: UserApiService,
  ) {
  }

  ngOnInit() {
    this.subscriptions.set('languageCode$', this.userApiService.languageCode$
      .subscribe(languageCode => this.setDisplayLanguage(languageCode))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onToggleMenu() {
    if (this.menuService.toggle()) {
      this.ordersApiService.update();
    }
  }

  setUserLanguage(languageCode: string) {
    this.userApiService.setCurrentUserLanguage(languageCode);
  }

  setDisplayLanguage(languageCode: string) {
    this.selectedLanguage = languageCode;
    this.translate.use(languageCode);
    this.adapter.setLocale(languageCode);
  }

  onHelp() {
    window.open('https://www.upmtimber.com/contacts/', '_blank');
  }

  onPrivacy() {
    const language = this.selectedLanguage === 'en-GB' ? '' : `${this.selectedLanguage}`;
    window.open(`https://privacy.upm.com/${language}`, '_blank');
  }

  onLegal() {
    window.open('http://www.upm.com/pages/legalnotice.aspx', '_blank');
  }

  logout() {
    // TODO: ?
    window.localStorage.removeItem('orderSelectedPackages');
    window.localStorage.removeItem('orderSelectedProducts');
    window.localStorage.removeItem('language');
    window.localStorage.removeItem('user');
    window.location.href = `${document.location.protocol}//${document.location.hostname}`;
  }

}
